export enum PurchasingGroupErrorCode {
    DUPLICATE_PURCHASING_GROUP_CODE = 'DUPLICATE_PURCHASING_GROUP_CODE',
    PURCHASING_GROUP_ASSIGNMENT_CONFLICT = 'PURCHASING_GROUP_ASSIGNMENT_CONFLICT',
    PURCHASING_GROUP_DEACTIVATION_REQUIRES_CONFIRMATION = 'PURCHASING_GROUP_DEACTIVATION_REQUIRES_CONFIRMATION',
    PURCHASING_GROUP_NOT_FOUND = 'PURCHASING_GROUP_NOT_FOUND',
    PURCHASING_GROUP_COMPANY_CODE_REMOVAL_BLOCKED = 'PURCHASING_GROUP_COMPANY_CODE_REMOVAL_BLOCKED',
    PURCHASING_GROUP_VALIDATION_ERROR = 'PURCHASING_GROUP_VALIDATION_ERROR',
    COMPANY_CODE_NOT_ASSIGNED_AT_HEADER = 'COMPANY_CODE_NOT_ASSIGNED_AT_HEADER',
    COMPANY_CODE_NOT_FOUND = 'COMPANY_CODE_NOT_FOUND',
    MATERIAL_GROUP_NOT_FOUND = 'MATERIAL_GROUP_NOT_FOUND',
    MATERIAL_GROUP_TENANT_MISMATCH = 'MATERIAL_GROUP_TENANT_MISMATCH',
    INACTIVE_PURCHASING_GROUP_ASSIGNMENT = 'INACTIVE_PURCHASING_GROUP_ASSIGNMENT',
    INACTIVE_CUSTOMER_USERS_ASSIGNMENT = 'INACTIVE_CUSTOMER_USERS_ASSIGNMENT',
    BULK_ASSIGNMENT_LIMIT_EXCEEDED = 'BULK_ASSIGNMENT_LIMIT_EXCEEDED',
}
